import {
  Button, Card, CardContent, CardHeader, colors, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControl,
  InputLabel, Select, TextField, Typography, createMuiTheme,
  Table, FormControlLabel, TableCell, TableRow, TableContainer, TableHead, Checkbox, Grid, MenuItem, Paper, Tooltip, IconButton, Backdrop
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import SendIcon from '@material-ui/icons/Send';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState, useRef } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import Alert from 'src/components/Alert';
import ForPartner from '../MaterialOrder/Create/ForPartner';
import axios from 'src/utils/axios';
import {
  getKoordinat, GetLocation, getUser, moneyFormat
} from 'src/utils/Common';
import {
  loadBaslandiJob, removeBaslandiJob, saveBaslandiJob
} from 'src/utils/storage/StartWorkOrder';
import { uploadFotograf } from 'src/utils/storage/StrPhoto';
import { setTask } from '../../store/actions/taskActions';
import AppReasonSearch from 'src/components/Selects/AppReasonSearch';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';
import AddIcon from '@material-ui/icons/Add';
import CloseIcon from '@material-ui/icons/Close';
import DateFnsUtils from '@date-io/date-fns';
import trLocale from 'date-fns/locale/tr';
import SatisfactionRating from 'src/components/Rating';
import axiosHeadOffice from 'src/utils/axiosHeadOffice';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import DeleteIcon from '@material-ui/icons/Delete';
import TriageMaterialOrder from 'src/views/MaterialOrder/Create/TriageMaterialOrder'
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import DefectTriage from '../WorkOrder/DefectTriage';
import RemoveShoppingCartIcon from '@material-ui/icons/RemoveShoppingCart';
import SaveIcon from '@material-ui/icons/Save';
import { getTasksRequest, resetModel } from '../../store/actions';
import ChecklistDialog from 'src/components/Checklist';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker
} from '@material-ui/pickers';
import { ThemeProvider } from '@material-ui/styles';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import WarningIcon from '@material-ui/icons/Warning';
import { paymentActions, paymentThunks } from 'src/store/slices/paymentSlice';


const useStyles = makeStyles((theme) => ({
  root: {},
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  policy: {
    display: 'flex',
    alignItems: 'center'
  },
  policyCheckbox: {
    marginLeft: '-14px'
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%',
  },
  button: {
    backgroundColor: "#27ae60",
    color: "#fff",
    border: "none",
    borderRadius: "5px",
    padding: "10px 20px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    outline: "none",
    "&:hover": {
      backgroundColor: "#1e8449",
    },
    "&:focus": {
      outline: "none",
    },
  },

}));

const siyah = '#424242';
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    }
  }
});
const localeMap = {
  tr: trLocale
};

const bookableStates = [
  { Id: 6, Dsc: 'Spare Part Ordered' },
  { Id: 11, Dsc: 'New Visit Required' }
]

function Sonlandir({
  className, customer, ReceiptNo, ReceiptNoParam, readonly, setReadonly, tasks, setTask, materialReducer, defectReducer, labourReducer, getTasksRequest,
  setBillingConsumer, techSurveysToCheck
}) {
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const [Uyari1, setUyari1] = React.useState('');
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [LoadingControl, setLoadingControl] = useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [islemYeri, setIslemYeri] = useState(0);
  const [tahsilatTipi, setTahsilatTipi] = useState(0);
  const [NewAppointment, setNewAppointment] = useState(null);
  const [tahsilatGoster, setTahsilatGoster] = useState(false);
  const [sonDurum, setSonDurum] = useState(0);
  const [sonDurumAciklama, setSonDurumAciklama] = useState(t('Son_Durum'));
  const [tutar, setTutar] = useState(0);
  const [openLegal, setOpenLegal] = useState(false);
  const [StatusData, setStatusData] = useState([]);
  const [PlaceData, setPlaceData] = useState([]);
  const [loading, setLoading] = useState(false);
  const SessionUser = getUser();
  const [MusteriBilgileri, setMusteriBilgileri] = React.useState('');
  const [AppointmentDateNew, setAppointmentDateNew] = useState(null);
  const [sourceOfDefect, setSourceOfDefect] = useState(0)
  const [sourceOfDefectData, setSourceOfDefectData] = useState([]);
  const [PaymentTypeData, setPaymentTypeData] = useState([]);
  const [IssueIdNew, setIssueIdNew] = useState(null);
  const [IssueIdNewData, setIssueIdNewData] = useState({});
  const [AppointmentDateEvent, setAppointmentDateEvent] = useState([]);
  const [ClosePopupControl, setClosePopupControl] = useState(false);
  const [ClosePopupHeader, setClosePopupHeader] = useState('');
  const [CloseBtn1, setCloseBtn1] = useState('');
  const [CloseBtn2, setCloseBtn2] = useState('');
  const [CloseTypePopupControl1, setCloseTypePopupControl1] = useState(0);
  const [CloseTypePopupControl2, setCloseTypePopupControl2] = useState(0);
  const [ReworkData, setReworkData] = useState([]);
  const [reworkDurum, setReworkDurum] = useState('0');
  const [MaterialOrderId, setMaterialOrderId] = useState(0);
  const [OpenMaterialOrder, setOpenMaterialOrder] = useState(false);
  const [WarrantyData, setWarrantyData] = useState([]);
  const [Compensation, setCompensation] = useState([]);
  const [RefurbishmentId, SetRefurbishmentId] = useState('0');
  const [RefurbishmentStorageLocationId, SetRefurbishmentStorageLocationId] = useState('0');
  const [RefurbishmentData, SetRefurbishmentData] = useState([]);
  const [RefurbishmentStorageLocationData, SetRefurbishmentStorageLocationData] = useState([]);
  const [ManufacturingFault, setManufacturingFault] = useState('');
  const [selectedMobileStatus, setSelectedMobileStatus] = useState('')
  const [rating, setRating] = useState(false);
  const [SatisfactionRate, setSatisfactionRate] = useState(0);
  const [Required, setRequired] = React.useState(false);
  const [defectsAndMaterials, setDefectsAndMaterials] = useState([]);
  const [defectAndMaterialList, setDefectAndMaterialList] = useState([]);
  const [OpenAIDialog, setOpenAIDialog] = useState(false);
  const [selectedDefect, setSelectedDefect] = useState(null);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [matchedPairs, setMatchedPairs] = useState([]);
  const [predictions, setPredictions] = useState([]);
  const [OpenTriageMaterialOrder, setOpenTriageMaterialOrder] = useState(false);
  const [IsAI, setIsAI] = useState(false)
  const [OrderNr, setOrderNr] = useState('');
  const [openCloseConfirm, setOpenCloseConfirm] = useState(false);

  const [discountParams, setDiscountParams] = useState([]);
  const [PayButtonActive, setPayButtonActive] = useState(false);
  const [showPaymentDialog, setShowPaymentDialog] = useState(false);
  const [showPaymentIframe, setShowPaymentIframe] = useState(false);
  const [paymentLocalError, setPaymentLocalError] = useState('');
  const [selectedPos, setSelectedPos] = useState('');
  const [SonucNotu, setSonucNotu] = useState('');
  const [ProjeKodu, setProjeKodu] = useState('');
  const [PaymentDetail, setPaymentDetail] = useState('');
  const [techSurveysNeedCompletion, settechSurveysNeedCompletion] = useState(null);
  const isOnline = useSelector((state) => state.status?.isOnline);

  const isCancelledRef = useRef(false);
  // Payment Redux state
  const repairData = useSelector(s => s.payment?.repairPreSaleData) || null;
  const repairLoading = useSelector(s => s.payment?.repairPreSaleLoading) === 'Loading';
  const repairError = useSelector(s => s.payment?.repairPreSaleError) || null;
  const posMatchingList = useSelector(s => s.payment?.employeePosMatchingList) || [];
  const posMatchingLoading = useSelector(s => s.payment?.employeePosMatchingLoading) === 'Loading';
  const repairOrderConditions = useSelector(s => s.payment?.repairOrderConditions) || [];
  const posTenantVatRateData = useSelector(s => s.payment?.posTenantVatRateData);
  const paymentRequestValidation = useSelector(s => s.payment?.paymentRequestValidation);
  const paymentRequestValidationLoading = useSelector(s => s.payment?.paymentRequestValidationLoading) === 'Loading';



  const { inputEnabled, comment } = useSelector((state) => state.testReducer);
  const dispatch = useDispatch();
  const history = useHistory();

  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: t('success_message')
  });

  const locale = localStorage.getItem('i18nextLng');
  const handleCloseopenLegal = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenLegal(false);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
  };
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const setIssue = (param) => {
    setIssueIdNew(param.Id);
    setIssueIdNewData({ IssueReason: param.Dsc, IssueReasonId: param.Id });
  };
  const setAppointmentData = value => {
    setNewAppointment(value);
  };

  const search = '';

  let SonlandirData = readonly ? tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)) : loadBaslandiJob();
  //let SonlandirData = loadBaslandiJob();

  // my Work
  useEffect(() => {
    // if (!loading) {
    localStorageKaydet();
    // }
    // eslint-disable-next-line
  }, [defectReducer, materialReducer, labourReducer]);

  const GetTenantDiscountCondition = () => {
    axios
      .get(`/GetTenantDiscountCondition`)
      .then(response => {
        if (response.data.length > 0) {
          setDiscountParams(response.data);
        }
      })
      .catch(error => {
        setDiscountParams([]);
      });
  };

  const localStorageKaydet = () => {
    // if (readonly) {
    //   return;
    // }
    if (defectReducer.Data.length === 0) {
      return;
    }
    let job = SonlandirData[0];
    const hizmetlerH = [];
    const isciliklerH = [];
    const malzemelerH = [];
    let iscilik_toplam = 0;
    let malzeme_toplam = 0;
    for (let h = 0; h < defectReducer.selected.length; h++) {
      const hizmet = defectReducer.selected[h];
      const hizmetRedux = defectReducer.defectsTable[hizmet];
      hizmetlerH.push({
        DefectId: hizmet,
        DefectCode: hizmetRedux?.UserCode,
        DefectDesc: hizmetRedux?.DefectDesc,
        // TIP: hizmetRedux?.DefectType,
        // TIP_KODU: hizmetRedux?.DefectTypeCode,
      });
      const labourArray = labourReducer[hizmet];
      if (labourArray && labourArray.length > 0) {
        for (let i = 0; i < labourArray.length; i++) {
          const iscilik = labourReducer.Data.filter((d) => d.LabourCode === labourArray[i])[0];
          if (iscilik) {
            isciliklerH.push({
              LabourId: iscilik.LabourId,
              DefectId: hizmet,
              LabourCode: iscilik.LabourCode,
              LabourDesc: iscilik.LabourDesc,
              Price: iscilik.Price,
              PriceWithWat: iscilik.PriceWithWat,
              VatRate: iscilik.VatRate,
              VatId: iscilik.VatId,
              LabourPriceListId: parseInt(job.WarrantyTypeId) === 1 ? iscilik.PriceListIdWithoutWarranty : iscilik.PriceListId,
              LabourPriceId: iscilik.PriceId
            });
            iscilik_toplam += parseInt(job.WarrantyTypeId) === 1 ? iscilik.PriceWithoutWarranty : iscilik.Price;
          }
        }
      }
      const materialArray = materialReducer[hizmet];
      if (materialArray && materialArray.length > 0) {
        for (let m = 0; m < materialArray.length; m++) {
          const malzeme = materialReducer.Data.filter((d) => d.MaterialCode === materialArray[m])[0];
          if (malzeme) {
            malzemelerH.push({
              MaterialId: malzeme.MaterialId,
              DefectId: hizmet,
              DefectDesc: hizmetRedux?.CategoryLevel1 + "/" + hizmetRedux?.CategoryLevel2 + "/" + hizmetRedux?.UserCode + "/" + hizmetRedux?.DefectDesc,
              MaterialCode: malzeme.MaterialCode,
              Count: materialReducer[malzeme.MaterialCode],
              MaterialDesc: malzeme.MaterialDesc,
              Price: malzeme.Price,
              PriceWithWat: malzeme.PriceWithWat,
              VatRate: malzeme.VatRate,
              VatId: malzeme.VatId,
              MaterialPriceListId: malzeme.PriceListId,
              MaterialPriceId: malzeme.PriceId
            });
            malzeme_toplam += materialReducer[malzeme.MaterialCode] * malzeme.PriceWithWat;
          }
        }
      }
    }
    job = {
      ...job,
      WorkOrderDetails: hizmetlerH,
      WorkOrderLabours: isciliklerH,
      WorkOrderMaterials: malzemelerH,
      EMploymentCostTotal: iscilik_toplam,
      MaterialTotal: malzeme_toplam,
    };
    saveBaslandiJob(job);
    SonlandirData = loadBaslandiJob();
  };


  // work end
  useEffect(() => {
  if (SonlandirData !== undefined && SonlandirData[0] !== undefined) {
    setSonucNotu(SonlandirData[0].Notes || '');
    setProjeKodu(SonlandirData[0].ProjectCode || '');
    }
  }, [SonlandirData]);

  let currMaterialSum = 0;
  let currLabourSum = 0;
  let currTransportSum = 0;
  let currExtraSum = 0;

  let currMaterialVatSum = 0;
  let currLabourVatSum = 0;
  let currTransportVatSum = 0;
  let currExtraVatSum = 0;

  const isPosTenantVat = posTenantVatRateData?.IsSuccess === true;
  const posTenantVatRateValue = posTenantVatRateData?.ResponseObject?.VatRate ?? 0.21;

  if (SonlandirData !== undefined && SonlandirData[0] !== undefined) {
    SonlandirData[0].WorkOrderMaterials.forEach((mrow, index) => {
      if (SonlandirData[0]?.WarrantyTypeId === 471) {
        currMaterialVatSum = 0;
        currMaterialSum = 0;
      }
      else {
        if (isPosTenantVat) {
          currMaterialSum += Math.round(mrow.PriceWithWat* 100) / 100 * mrow.Count;
          currMaterialVatSum += Math.round(mrow.Price * 100) / 100 * mrow.Count;
        } else {
          currMaterialSum += mrow.PriceWithWat * mrow.Count;
          currMaterialVatSum += mrow.Price * mrow.Count;
        }
      }
    });
    SonlandirData[0].WorkOrderLabours.forEach((mrow, index) => {
      if (isPosTenantVat) {
        currLabourSum += Math.round(mrow.PriceWithWat * 100) / 100;
        currLabourVatSum += Math.round(mrow.Price * 100) / 100;
      } else {
        currLabourSum += mrow.PriceWithWat;
        currLabourVatSum += mrow.Price;
      }
    });
    SonlandirData[0].WorkOrderTransport.forEach((mrow, index) => {
      if (isPosTenantVat) {
        currTransportSum += Math.round(mrow.MaterialPriceWithWat * 100) / 100;
        currTransportVatSum += Math.round(mrow.MaterialPrice * 100) / 100;
      } else {
        currTransportSum += mrow.MaterialPriceWithWat;
        currTransportVatSum += mrow.MaterialPrice;
      }
    });
    SonlandirData[0].WorkOrderExtra.forEach((mrow, index) => {
      if (isPosTenantVat) {
        currExtraSum += Math.round(mrow.MaterialPriceWithWat * 100) / 100;
        currExtraVatSum += Math.round(mrow.MaterialPrice * 100) / 100;
      } else {
        currExtraSum += mrow.MaterialPriceWithWat;
        currExtraVatSum += mrow.MaterialPrice;
      }
    });
  }


  const CheckToPassNextStepsWithTechnicianSurveysStatuses = async function (selectedStatus) {


    if (techSurveysToCheck != null && techSurveysToCheck.length > 0 && selectedStatus != null) {
      var surveys = techSurveysToCheck.filter((survey) => (survey.IsActive == true && survey.IsCompleted == false));
      if (surveys.length > 0) {

        //backend api designed to gather all triggerstatuses- also for each survey - which are possible matches for above at first level (and each), so no panic..
        var statusesToCheckBeforeTechnicianSurveyCompleted = surveys[0]?.SurveyCheckTriggerAlertStatuses;
        var selectedStatusMatch = statusesToCheckBeforeTechnicianSurveyCompleted.some((x) => x === selectedStatus);
        if (selectedStatusMatch) {

          let response = await getTechnicianSurveysStatusesForWorkOrder(ReceiptNo);
          let retVal = response;

          if (retVal == true) {
            return false;
          }
          else {
            return true;
          }
        }
      }

    }
    if (techSurveysToCheck == null) {
      return null;
    }
    else {
      return true;
    }

  }

  const getTechnicianSurveysStatusesForWorkOrder = async function (workOrderId) {
    return await axios
      .get(
        `/GetTechnicianSurveys/${workOrderId}`
      )
      .then(response => {
        if (response.data == null || response.data.StatusCode != 200) {
          alert("An error occured while fetching survey data for technicians!!. Please check error logs.");
        } else {
          if (response.data.Result.length > 0) {

            var results = response.data.Result;
            if (results.some(e => e.IsCompleted === false)) {
              settechSurveysNeedCompletion(true);
              return true;
            }
            else {
              settechSurveysNeedCompletion(false);
              return false;
            }
          }
        }
      })
      .catch(error => {
        console.error(error);
      });
  };

  const GetPlace = () => {

    axios
      .get('/GetPlace')
      .then((response) => {
        if (response.data.length > 0) {
          setPlaceData(response.data);
        }
      })
      .catch((error) => { });
  };

  const GetWarranty = () => {
    axios
      .get(`/GetSiriusWarrantyType`)
      .then(response => {
        if (response.data.length > 0) {
          setWarrantyData(response.data);
        }
      })
      .catch(error => { });
  };
  var WarrantyTypeId = WarrantyData.filter(x => x.WarrantyId == SonlandirData[0].WarrantyTypeId);
  const warrantyGroupId = WarrantyTypeId[0]?.WarrantyGroupId;
  useEffect(() => {
    console.log("Warranty Group ID:", warrantyGroupId, "Tahsilat Tipi:", tahsilatTipi, "RepairOrderConditions:", repairOrderConditions);
    if (repairOrderConditions.length > 0) {
      // Backend'den gelen koşullara göre ödeme butonu aktif/pasif yapılıyor
      const match = repairOrderConditions.some(
        c => c.Active && c.WarrantyGroupId === warrantyGroupId && c.PaymentTypeId === parseInt(tahsilatTipi)
      );
      setPayButtonActive(match);
    } else {   
      setPayButtonActive(false);
    }
  }, [warrantyGroupId, tahsilatTipi, repairOrderConditions]);

  const GetActivePaymentTypes = () => {
    axios
      .get(`/GetActivePaymentTypes`)
      .then(response => {
        if (response.data.length > 0) {
          setPaymentTypeData(response.data);
          if (SonlandirData === undefined || SonlandirData[0] === undefined) {
            return;
          }
          setTahsilatTipi(SonlandirData[0].PaymentTypeId || 0);
        }
      })
      .catch(error => { });
  };

  const GetActiveReworkStatus = () => {
    axios
      .get(`/GetActiveReworkStatus`)
      .then(response => {
        if (response.data.length > 0) {
          setReworkData(response.data);
        }
      })
      .catch(error => { });
  };

  const GetRefurbishmentGrade = () => {
    axios
      .get(`/GetRefurbishmentGrade`)
      .then(response => {
        if (response.data.length > 0) {
          SetRefurbishmentData(response.data);
        }
      })
      .catch(error => { });
  };


  const GetRefurbishmentStorageLocations = () => {
    axios
      .get(`/GetStorageLocationsByTypeId/1`)
      .then(response => {

        console.log(response.data)
        if (response.data.length === 1) {
          console.log("geldi");
          SetRefurbishmentStorageLocationId(response.data[0].Id);
          let job = loadBaslandiJob()[0];
          job = {
            ...job,
            RefurbishmentStorageLocationId: response.data[0].Id
          };
          saveBaslandiJob(job);
          console.log("gitti");
        }

        if (response.data.length > 0) {
          SetRefurbishmentStorageLocationData(response.data);
        }
      })
      .catch(error => { });
  };

  const GetSourceOfDefectTypes = () => {
    axios
      .get(`/GetSourceOfDefectTypes`)
      .then(response => {
        if (response.data.length > 0) {
          setSourceOfDefectData(response.data);
        }
      })
      .catch(error => { });
  };

  const getCompensation = () => {
    axios
      .get(
        `/GetCompensationSS/${ReceiptNo || 0}`
      )
      .then(response => {
        if (response.data.length > 0 && response.data != "") {
          setCompensation(response.data);
          setManufacturingFault(response.data[0].ManufacturingFault);
        } else {
          setCompensation([]); //no data
        }
      })
      .catch(error => {
        setUyariTip('error');
        setUyari(true);
      });
  };

  useEffect(() => {
    if (isOnline) {
      var UserTypeId = SessionUser.TechnicianId;
      var OldStatusId = SonlandirData[0]?.LatestStatus;
      axios.get('/GetWorkOrderStatusLogic/' + OldStatusId + '/' + UserTypeId + '/' + ReceiptNo).then((response) => {
        const Deger = response.data;
        setStatusData(Deger);
        setSelectedMobileStatus(Deger.find(i => i.StatusId == SonlandirData[0].LatestStatus)?.MobileStatusId)
        setLoadingControl(false);
      }).catch((error) => {
        setStatusData([]);
        setLoadingControl(false);
      });
      setSonDurum(SonlandirData[0]?.LatestStatus || 0);
      setSourceOfDefect(SonlandirData[0].SourceOfDefect || 0);
    }
  }, [SessionUser.ServiceShopId, isOnline]);

  useEffect(() => {
    if (isOnline) {
      GetLocation();
      GetPlace();
      GetWarranty();
      GetActiveReworkStatus();
      GetRefurbishmentGrade();
      GetChecklistItems();


      GetRefurbishmentStorageLocations();
      GetSourceOfDefectTypes();

      GetTenantDiscountCondition();
      GetActivePaymentTypes();
      dispatch(paymentThunks.GetRepairOrderCondition());
      dispatch(paymentThunks.GetPosTenantVatRate());
      if (SonlandirData === undefined || SonlandirData[0] === undefined) {
        return;
      }

      getCompensation();
      setIslemYeri(SonlandirData[0].OperationPlaceId || 0);
      setTahsilatGoster(true);
      setReworkDurum(SonlandirData[0]?.ReworkId || 0);
      setSonucNotu(SonlandirData[0].Notes || '');
      setProjeKodu(SonlandirData[0].ProjectCode || '');
      SetRefurbishmentId(SonlandirData[0].RefurbishmentId || 0);
      setPaymentDetail(SonlandirData[0].PaymentDetail || '');
      SetRefurbishmentStorageLocationId(SonlandirData[0].RefurbishmentStorageLocationId || 0);
      setPaymentDetail(SonlandirData[0].PaymentDetail || '');
      setLoadingControl(true);
    }
  }, [isOnline]);


  const handleChangeDurum = (event) => {
    var MobileStatusId = StatusData.filter(i => i.StatusId == event.target.value)[0].MobileStatusId
    setSelectedMobileStatus(MobileStatusId)
    setIsAI(StatusData.filter(i => i.StatusId == event.target.value)[0].IsAI);

    if (readonly) {
      return;
    }
    const index = event.target.selectedIndex;
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      LatestStatus: event.target.value,
    };
    saveBaslandiJob(job);
    setSonDurum(event.target.value);
    setSonDurumAciklama(event.target[index].text);
  };
  // const handleChangeTutar = (value) => {
  //   let job = loadBaslandiJob()[0];
  //   job = {
  //     ...job,
  //     DiscountAmountTotal: value,
  //   };
  //   saveBaslandiJob(job);
  //   setTutar(value);
  // };

  let dscType = SonlandirData[0]?.DiscountTypeId || 0;
  let rtType = SonlandirData[0]?.DiscountRateId || 0;
  const [DiscountTypeId, SetDiscountTypeId] = useState(dscType);
  const [DiscountRateId, SetDiscountRateId] = useState(rtType);

  const handleChangeDiscountType = event => {
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      DiscountTypeId: event.target.value,
    };
    saveBaslandiJob(job);
    SetDiscountTypeId(event.target.value)
  };

  const handleChangeDiscountRate = event => {
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      DiscountRateId: event.target.value,
    };
    saveBaslandiJob(job);
    SetDiscountRateId(event.target.value)
  };

  const handleChangeIslemYeri = (event) => {
    if (readonly) {
      return;
    }
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      OperationPlaceId: event.target.value,
    };
    saveBaslandiJob(job);
    setIslemYeri(event.target.value);
  };

  const handleChangeTahsilatTipi = (event) => {
    if (readonly) {
      return;
    }
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      PaymentTypeId: event.target.value,
    };
    saveBaslandiJob(job);
    setTahsilatTipi(event.target.value);
  };

  const handleChangePaymentDetail = event => {
    if (readonly) {
      return;
    }
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      PaymentDetail: event.target.value
    };
    saveBaslandiJob(job);
    setPaymentDetail(event.target.value);
  };

  const handleChangeRework = event => {
    if (readonly) {
      return;
    }
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      ReworkId: event.target.value
    };
    saveBaslandiJob(job);
    setReworkDurum(event.target.value);

  };

  const handleChangeRefurbishment = event => {
    if (readonly) {
      return;
    }
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      RefurbishmentId: event.target.value
    };
    saveBaslandiJob(job);
    SetRefurbishmentId(event.target.value);
  };

  const handleChangeRefurbishmentStorageLocation = event => {
    if (readonly) {
      return;
    }
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      RefurbishmentStorageLocationId: event.target.value
    };
    saveBaslandiJob(job);
    SetRefurbishmentStorageLocationId(event.target.value);
  };

  const handleChangeSonucNotu = (event) => {
    if (readonly) {
      return;
    }
    if (openLegal === false) {
      setOpenLegal(true);
    }

    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      Notes: event.target.value,
    };
    saveBaslandiJob(job);
    setSonucNotu(event.target.value);
  };

  const handleChangeProjeKodu = (event) => {
    if (readonly) {
      return;
    }
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      ProjectCode: event.target.value,
    };
    saveBaslandiJob(job);
    setProjeKodu(event.target.value);
  };

  const [checklistItems, setChecklistItems] = useState([]);
  const [checklistOpen, setChecklistOpen] = useState(false);
  const [checklistRequired, setChecklistRequired] = useState(false);
  const [checklistTitle, setChecklistTitle] = useState('');
  const [checklistConfirmText, setChecklistConfirmText] = useState('');

  const GetChecklistItems = () => {
    axiosHeadOffice
      .get(`/GetChecklistItems`)
      .then(response => {
        if (response.data.length > 0) {
          setChecklistTitle(t('lblChecklistTitle'));
          setChecklistConfirmText(t('lblChecklistConfirmText'));
          setChecklistItems(response.data.slice(0).map((label, index) => ({
            id: index + 1, // veya unique bir id değeri kullan
            label: label
          })));

        }
      })
      .catch(error => {
        console.error('Error fetching checklist items:', error);
      });
  };



  const handleSendToCenter = async () => {
    // Kontrol listesi gerekli mi kontrolü eklecenek
    // API'den checklist durumunu al
    const response = await axiosHeadOffice.get('/IsActive/Checklist');
    const checklistRequired = response.data === true;
    // Kontrol listesi gerekli ise aç && (selectedMobileStatus == 8 || selectedMobileStatus == 49)
    if (checklistRequired && (selectedMobileStatus == 8 || selectedMobileStatus == 49)) {
      setChecklistOpen(true);
      return;
    }
    else {
      handleMerkezeGonder();
    }
  };
  const handleChecklistSave = (checkedItems) => {
    // Kontrol listesi onaylandıktan sonra formu gönder
    handleMerkezeGonder();
    setChecklistOpen(false);
  };


  async function sendToSatisfactionRate() {

    //check if the technician has survey(s) before sending this workorder to action for certain statuses which comes from data - triggerStatuses
    var isTechnicianHasSurveysBeforePassingToNextSteps = await CheckToPassNextStepsWithTechnicianSurveysStatuses(selectedMobileStatus, techSurveysToCheck);

    if (isTechnicianHasSurveysBeforePassingToNextSteps != null && isTechnicianHasSurveysBeforePassingToNextSteps == false) {
      alert("Please complete required survey(s) from tab in order to go to next step for this workorder. Thank you.");
    }
    else {
      handleSendToCenter();
      localStorageKaydet();
      duplcatingArray();
    }


    // if (selectedMobileStatus == 8 || selectedMobileStatus == 49 && SatisfactionRate == 0) {
    //   setRating(true);
    // } else {
    //   handleMerkezeGonder();
    // }
  }

  const sendRepairCompletedDate = () => {
    let item = {
      repairDate: new Date().toISOString(),
      technicianId: SessionUser.TechnicianId,
      workOrderId: parseInt(ReceiptNo)
    };

    localStorage.setItem('repairCompletedLogs', JSON.stringify(item));
    setUyariTip('success');
    setUyariAciklama("Success");
    setReadonly(true);
  }

  const handleMakeBookingButtonOnClick = e => {
    history.push('/UndatedWorkOrder');
  }

  // Payment - RepairPreSale handlers
  const totalWithVat = Math.round(currMaterialSum * 100) / 100
    + Math.round(currLabourSum * 100) / 100
    + Math.round(currTransportSum * 100) / 100
    + Math.round(currExtraSum * 100) / 100;
  const paymentCur = SessionUser.CurrencyUnit || '';
  const paymentIframeUrl = repairData?.PaymentUrl;

  const handleOpenPaymentDialog = () => {
    setPaymentLocalError('');
    setShowPaymentIframe(false);
    dispatch(paymentActions.clearRepairPreSale());
    dispatch(paymentActions.clearPaymentRequestValidation());
    // Fetch POS machines
    const employeeId = parseInt(SessionUser?.TechnicianId) || 0;
    if (employeeId > 0) {
      dispatch(paymentThunks.GetEmployeePosMatching(employeeId));
    }
    // Check if a payment request was already sent for this work order
    dispatch(paymentThunks.CheckPaymentRequestIsAlreadySent({ WorkOrderId: parseInt(ReceiptNo) }));
    setShowPaymentDialog(true);
  };

  const GetSiriusPricingInfos = () => {
    const products = [];
    let roundedTotal = 0;
    const job = SonlandirData[0];
    if (!job) return { products, roundedTotal };

    (job.WorkOrderMaterials || []).forEach(material => {
      const roundedPrice = Math.round((material.PriceWithWat || 0) * 100) / 100;
      const qty = material.Count || 1;
      roundedTotal += roundedPrice * qty;

      products.push({
        Um: 'pcs',
        Name: material.MaterialDesc,
        ProductId: material.MaterialId,
        ProductSku: material.MaterialCode,
        // Price: (roundedPrice).toFixed(2),
        Price: String(roundedPrice),
        VatId: "A",
        Quantity: String(qty)
      });
    });

    (job.WorkOrderLabours || []).forEach(labour => {
      const roundedPrice = Math.round((labour.PriceWithWat || 0) * 100) / 100;
      roundedTotal += roundedPrice;
      products.push({
        Um: 'pcs',
        Name: labour.LabourDesc,
        ProductId: labour.LabourId,
        ProductSku: labour.LabourCode,
        // Price: roundedPrice.toFixed(2),
        Price: String(roundedPrice),
        VatId: "A",
        Quantity: '1'
      });
    });

    (job.WorkOrderTransport || []).forEach(transport => {
      const roundedPrice = Math.round((transport.MaterialPriceWithWat || 0) * 100) / 100;
      roundedTotal += roundedPrice;
      products.push({
        Um: 'pcs',
        Name: 'Transport',
        ProductId: transport.Id || 0,
        ProductSku: '',
        // Price: roundedPrice.toFixed(2),
        Price: String(roundedPrice),
        VatId: "A",
        Quantity: '1'
      });
    });

    (job.WorkOrderExtra || []).forEach(extra => {
      const roundedPrice = Math.round((extra.MaterialPriceWithWat || 0) * 100) / 100;
      roundedTotal += roundedPrice;
      products.push({
        Um: 'pcs',
        Name: 'Extra Cost',
        ProductId: extra.Id || 0,
        ProductSku: '',
        // Price: roundedPrice.toFixed(2),
        Price: String(roundedPrice),
        VatId: "A",
        Quantity: '1'
      });
    });

    // roundedTotal = Math.round(roundedTotal * 100) / 100;
    // const difference = Math.round((totalWithVat - roundedTotal) * 100) / 100;

    // if (products.length > 0 && difference !== 0) {
    //   const firstPrice = parseFloat(products[0].Price) || 0;
    //   const adjustedFirstPrice = Math.round((firstPrice + difference) * 100) / 100;
    //   products[0].Price = adjustedFirstPrice.toFixed(2);
    //   roundedTotal = Math.round((roundedTotal + difference) * 100) / 100;
    // }

    return { products, roundedTotal };
  };

  const handleRepairPreSale = () => {
    setPaymentLocalError('');
    setShowPaymentIframe(false);
    dispatch(paymentActions.clearRepairPreSale());

    const { products, roundedTotal } = GetSiriusPricingInfos();

    const dto = {
      ApplicationReference: String(ReceiptNo || ''),
      Amount: roundedTotal,
      Currency: paymentCur.toUpperCase() || 'RON',
      UserRef: selectedPos || '',
      Products: products,
      AdditionalMetaData: '',
      LanguageCode: '',
      CreateEmployeeId: null,
      ConsumerId: null
    };

    dispatch(paymentThunks.RepairPreSale(dto))
      .then(resp => {
        const payload = resp?.payload;
        if (resp?.error) {
          setPaymentLocalError(resp.error.message || 'RepairPreSale failed.');
          return;
        }
        if (payload?.PaymentUrl) {
          setShowPaymentIframe(true);
        }
      })
      .catch(err => {
        setPaymentLocalError(err?.message || 'RepairPreSale exception.');
      });
  };

  const handleClosePaymentDialog = () => {
    setShowPaymentDialog(false);
    setShowPaymentIframe(false);
    setSelectedPos('');
    dispatch(paymentActions.clearRepairPreSale());
    dispatch(paymentActions.clearEmployeePosMatching());
    dispatch(paymentActions.clearPaymentRequestValidation());
  };


  const [error, setError] = useState(false);
  const [OpenUsedNotUsedDialog, setOpenUsedNotUsedDialog] = useState(false);
  const [cloneArray, setCloneArray] = useState([])
  const duplcatingArray = () => {
    let itemArray = [];
    const change = SonlandirData[0]?.WorkOrderMaterials.map((data) => (
      Array.from({ length: data?.Count }, (v, i) => {
        itemArray.push(data)
      })
    ))
    const duplicatedArray = itemArray.map((item) => ({ ...item, is_selected: null }))
    setCloneArray(duplicatedArray)
  }
  const clearUnusedItemsCheckBox = () => {
    const newValue = cloneArray.map((data) => ({ ...data, is_selected: null }))
    setCloneArray(newValue)
  }
  function checkSelection({ index, value, id }) {
    const newValue = cloneArray.map((item, key) => {
      if (key === index) {
        item.is_selected = value;
      }
      return item;
    })
    setCloneArray(newValue);
  }

  const checkAll = () => {
    const updatedItems = cloneArray.map(item => ({
      ...item,
      is_selected: true,
    }));
    setCloneArray(updatedItems);
  };

  const handleSelectedUnusedItems = () => {
    let count = 0;
    cloneArray.map((data) => {
      if (data.is_selected === null) {
        count = 1
      }

    })
    if (count > 0 && OpenUsedNotUsedDialog) {
      setError(true)
    } else {
      setError(false)
      setOpenUsedNotUsedDialog(false)
      // setOpenMaterialOrder(true)
      setClosePopupControl(true);
    }
  }
  useEffect(() => {
    duplcatingArray()
  }, [tasks, materialReducer])
  // end work
  const handleMerkezeGonder = (event, CloseType) => {
    const MerkezeGonderilecekData = loadBaslandiJob();
    var sonDurum = parseInt(MerkezeGonderilecekData[0].LatestStatus);
    setLoadingControl(true);
    axios
      .get(`/GetClosePopupControl/` + parseInt(sonDurum))
      .then(response => {
        if (parseInt(response.data) === 0) {
          handleMerkezeGonderPopup0(event, CloseType);
        }
        if (parseInt(response.data) === 1) {
          setClosePopupHeader(t('lblClosePopup1'));
          setCloseBtn1(t('lblCloseBtn1'));
          setCloseBtn2(t('lblCloseBtn2'));
          setCloseTypePopupControl1(1);
          setCloseTypePopupControl2(2);
          setClosePopupControl(true);
        }
        if (parseInt(response.data) === 2) {
          setClosePopupHeader(t('lblClosePopup2'));
          setCloseBtn1(t('lblCloseBtn5'));
          setCloseBtn2(t('lblCloseBtn6'));
          setCloseTypePopupControl1(5);
          setCloseTypePopupControl2(6);
          setClosePopupControl(true);
        }
        //Ye Comment tha mene khol dia
        if (parseInt(response.data) === 3) {
          if (SonlandirData[0]?.WorkOrderMaterials?.length > 0 && SessionUser.TenantId != 37 && SessionUser.TenantId != 70) {
            setOpenUsedNotUsedDialog(true);
          } else {
            setOpenUsedNotUsedDialog(false);
            setClosePopupControl(true)
            checkAll();
          }
          setClosePopupHeader(t('lblClosePopup3'));
          setCloseBtn1(t('lblCloseBtn3'));
          setCloseBtn2(t('lblCloseBtn4'));
          setCloseTypePopupControl1(3);
          setCloseTypePopupControl2(4);
          //  setClosePopupControl(true);
        }
        setLoadingControl(false);
      })
      .catch(error => {
        setLoadingControl(false);
      });
  };

  const handleMerkezeGonderPopup0 = (event, CloseType) => {
    confirmAlert({
      message: t('Barcode_warning'),
      buttons: [
        {
          label: t('Evet'),
          onClick: () => handleMerkezeGonderEvet(event, CloseType)
        },
        {
          label: t('Hayir'),
          onClick: () => { }
        }
      ]
    });
  }
  const handleMerkezeGonderEvet = async (event, CloseType) => {
    setRequired(true);
    if (readonly) {
      return;
    }
    if (CloseType === 2) {
      setClosePopupControl(false);
      return;
    }
    if (CloseType === 4) {
      setClosePopupControl(false);
      return;
    }
    try {
      setLoadingControl(true);
      setOpen1(false);
      const StatusId = parseInt(sonDurum);
      await uploadFotograf(ReceiptNo);
      const MerkezeGonderilecekData = loadBaslandiJob();
      const reasonData = loadBaslandiJob()[0];
      const StatusLatitude = getKoordinat('Enlem');
      const StatusLongitude = getKoordinat('Boylam');
      if (CloseType === 3) {
        let filterWorkOrderMaterials = []
        let oldValues = []
        if (MerkezeGonderilecekData[0]?.WorkOrderMaterials?.length > 0) {
          MerkezeGonderilecekData[0].WorkOrderMaterials.forEach((mrow, index) => {
            let Count = 0;
            let CountMaterial = 0
            cloneArray.forEach((irow, iindex) => {
              if (mrow.DefectId === irow.DefectId && mrow.MaterialId === irow.MaterialId && irow.is_selected === true) {
                Count++;
                CountMaterial++
              }
            })
            if (CountMaterial == 0) {
              delete materialReducer[mrow.MaterialCode]
              const selected = materialReducer[mrow.DefectId]
              const deleteIndex = selected.indexOf(mrow.MaterialCode)
              materialReducer[mrow.DefectId].splice(deleteIndex, 1)
            } else {
              materialReducer[mrow.MaterialCode] = CountMaterial
              CountMaterial = 0;
            }
            if (Count > 0) {
              filterWorkOrderMaterials.push({
                Count: Count,
                DefectId: mrow.DefectId,
                DefectDesc: mrow.DefectDesc,
                MaterialCode: mrow.MaterialCode,
                MaterialDesc: mrow.MaterialDesc,
                MaterialId: mrow.MaterialId,
                MaterialPriceId: mrow.MaterialPriceId,
                MaterialPriceListId: mrow.MaterialPriceListId,
                Price: mrow.Price,
                PriceWithWat: mrow.PriceWithWat,
                VatId: mrow.VatRateId,
                VatRate: mrow.VatRate
              })
            }

          })
        }
        MerkezeGonderilecekData.WorkOrderMaterials = filterWorkOrderMaterials
      }
      localStorageKaydet();

      let finalObject = {};
      let testsValues = [];
      if (SessionUser.TenantId === 16 && Object.keys(inputEnabled).length > 0) {

        testsValues = Object.values(inputEnabled).map(item => ({
          state: item.state,
          id: item.id,
          value: item.value,
          value1: item.value1,
          dataType: item.dataType
        }));

        finalObject = {
          comment: comment,
          testsValues: testsValues
        }
      }

      const data = [{
        WorkOrderId: parseInt(MerkezeGonderilecekData[0].ReceiptNo) || 0,
        WorkCaseId: parseInt(MerkezeGonderilecekData[0].WorkCaseId) || 0,
        ServiceShopId: parseInt(SessionUser.ServiceShopId) || 0,
        ConsumerId: parseInt(MerkezeGonderilecekData[0].CustomerNo) || 0,
        ConsumerAddressId: parseInt(MerkezeGonderilecekData[0].ConsumerAddressId) || 0,
        ContactName: MerkezeGonderilecekData[0].ContactName || '',
        ContactPhone: MerkezeGonderilecekData[0].ContactPhone || '',
        EmployeeId: parseInt(SessionUser.TechnicianId) || 0,
        ModelCode: MerkezeGonderilecekData[0].ModelCode || '',
        ProductionYear: parseInt(MerkezeGonderilecekData[0].ProductionYear) || 0,
        ProductionMonth: parseInt(MerkezeGonderilecekData[0].ProductionMonth) || 0,
        SerialNumber: MerkezeGonderilecekData[0].SerialNumber.toString() || '',
        AttributeId: parseInt(MerkezeGonderilecekData[0].AttributeId) || 0,
        WarrantyDate: MerkezeGonderilecekData[0].WarrantyDate || '',
        WarrantyTypeId: parseInt(MerkezeGonderilecekData[0].WarrantyTypeId) || 0,
        LatestStatus: parseInt(MerkezeGonderilecekData[0].LatestStatus) || 0,
        OperationPlaceId: parseInt(MerkezeGonderilecekData[0].OperationPlaceId) || 0,
        Notes: MerkezeGonderilecekData[0].Notes || '',
        StatusLatitude: StatusLatitude || '',
        StatusLongitude: StatusLongitude || '',
        IssueId: parseInt(MerkezeGonderilecekData[0].IssueReasonId) || 0,
        RetailerId: parseInt(MerkezeGonderilecekData[0].RetailerId) || 0,
        PaymentTypeId: parseInt(MerkezeGonderilecekData[0].PaymentTypeId) || 0,
        ReworkId: parseInt(MerkezeGonderilecekData[0].ReworkId) || 0,
        DiscountAmountTotal: MerkezeGonderilecekData[0].DiscountAmountTotal || 0,
        ProjectCode: MerkezeGonderilecekData[0].ProjectCode || '',
        ServiceErrorCode: MerkezeGonderilecekData[0].ServiceErrorCode || '',
        CustomerErrorCode: MerkezeGonderilecekData[0].CustomerErrorCode || '',
        UpdateUserId: parseInt(SessionUser.TechnicianId) || 0,
        ChannelId: parseInt(MerkezeGonderilecekData[0].ChannelId) || 1,
        AppointmentDate: MerkezeGonderilecekData[0].AppointmentDate || '',
        AppointmentEndDate:
          MerkezeGonderilecekData[0].AppointmentEndDate || '',
        PriorityId: parseInt(MerkezeGonderilecekData[0].PriorityId) || 1,
        UrgentCustomer: MerkezeGonderilecekData[0].UrgentCustomer || 0,
        PotentialLiabiltiy: MerkezeGonderilecekData[0].PotentialLiabilityActive || 0,
        NoInvoice: MerkezeGonderilecekData[0].NoInvoice || false,
        SourceOfDefect: sourceOfDefect || 0,
        PreferredDate: MerkezeGonderilecekData[0].PreferredDate || '',
        Defects: (MerkezeGonderilecekData[0].WorkOrderDetails || []).map((h) => ({ DefectId: h.DefectId })) || [],
        Labours: MerkezeGonderilecekData[0].WorkOrderLabours || [],
        Materials: MerkezeGonderilecekData[0].WorkOrderMaterials || [],
        DistributorId: MerkezeGonderilecekData[0].DistributorId || 0,
        TaskTypeId: MerkezeGonderilecekData[0].TaskTypeId || 0,
        Barcode: MerkezeGonderilecekData[0].Barcode || '',
        UsedNotUsedMaterialData: cloneArray || [],
        DiscountTypeId: MerkezeGonderilecekData[0].DiscountTypeId,
        DiscountRateId: MerkezeGonderilecekData[0].DiscountRateId,
        RefurbishmentId: parseInt(MerkezeGonderilecekData[0].RefurbishmentId) || 0,
        RefurbishmentStorageLocationId: parseInt(MerkezeGonderilecekData[0].RefurbishmentStorageLocationId) || 0,
        CloseType: CloseType,
        BarcodeDate: MerkezeGonderilecekData[0].BarcodeDate || '',  //check
        ChangeTaxOffice: MerkezeGonderilecekData[0].ChangeTaxOffice || '', //check
        ChangeTaxId: MerkezeGonderilecekData[0].ChangeTaxId || '', //check
        ChangeIdNumber: MerkezeGonderilecekData[0].ChangeIdNumber || '', //check
        ChangeType: MerkezeGonderilecekData[0].ChangeType || 0, //
        ChangeReason: reasonData.ChangeReason || 0, //check
        ChangeReasonDetail: reasonData.ChangeReasonDetail || 0,//check
        ChangeGrade: MerkezeGonderilecekData[0].ChangeGrade || 0,//check
        ChangeUpgrade: MerkezeGonderilecekData[0].Upgrade || 0,//check
        ChangeServiceNote: MerkezeGonderilecekData[0].ChangeServiceNote || '',//check
        ChangeReceived: MerkezeGonderilecekData[0].ChangeReceived || 0,//check
        ChangeBankName: MerkezeGonderilecekData[0].ChangeBankName || '',//check
        ChangeBankCode: MerkezeGonderilecekData[0].ChangeBankCode || '',//check
        ChangeIban: MerkezeGonderilecekData[0].ChangeIban || '',//check
        ChangeInvoiceNr: MerkezeGonderilecekData[0].ChangeInvoiceNr || '',//check
        ChangeInvoiceDate: MerkezeGonderilecekData[0].ChangeInvoiceDate || '',//check
        ChangeInvoicePrice: MerkezeGonderilecekData[0].ChangeInvoicePrice || 0,//check
        ChangeProductId: MerkezeGonderilecekData[0].ChangeProductId || 0,//check
        ExchangeMaterialOrderNr: MerkezeGonderilecekData[0].ExchangeMaterialOrderNr || '',//check
        ChangeUnavailableMaterial: (MerkezeGonderilecekData[0].ChangeUnavailableMaterial || []).map((h) => ({ MaterialCode: h.MaterialCode })) || [], //check
        BillingRetailer: (MerkezeGonderilecekData[0].BillingRetailer || []),
        BillingConsumer: (MerkezeGonderilecekData[0].BillingConsumer || []),
        PaymentDetail: MerkezeGonderilecekData[0].PaymentDetail || '',
        Tests: finalObject
      }];

      const config = {
        headers: { 'Content-Type': 'application/json' }
      };
      // if (selectedMobileStatus == 8 || selectedMobileStatus == 49 && SatisfactionRate == 0) {
      //   setRating(true);
      // }

      // if (selectedMobileStatus == 11 && SonlandirData[0].PotentialLiabilityActive == 1 && ManufacturingFault == '') {
      //   //Selected New Visit Required and click potential liability claim but compensation form is empty
      //   //(we can understand if manufacturingfault is empty then compensation form is not filled because it is a mandatory)
      //   setLoadingControl(false);
      //   setClosePopupControl(false);
      //   setUyariTip('error');
      //   setUyariAciklama(t('lblCompensationError'));
      //   setUyari(true);
      //   return;
      // }



      if (MerkezeGonderilecekData[0]?.FormRequired == 1 && ManufacturingFault == '') {
        //If FormRequired is true but compensation form is empty.
        //(we can understand if manufacturingfault is empty then compensation form is not filled because it is a mandatory)
        setLoadingControl(false);
        setClosePopupControl(false);
        setUyariTip('error');
        setUyariAciklama(t('lblCompensationError'));
        setUyari(true);
        return;
      } else {
        if (selectedMobileStatus == 9 && MerkezeGonderilecekData[0]?.Confirmed == 0) {
          //You cannot update if the form is mandatory and not confirmed.
          setLoadingControl(false);
          setClosePopupControl(false);
          setUyariTip('error');
          setUyariAciklama(t('lblConfirmedError'));
          setUyari(true);
          return;
        }
      }

      if (IsAI === true) {
        AIPrediction();
        setOpenAIDialog(true);
        return;
      }

      if (SessionUser.TenantId === 16 && Object.keys(inputEnabled).length === 0) {
        setLoadingControl(false);
        setClosePopupControl(false);
        setUyariTip('error');
        setUyariAciklama('You must fill the fields in the Tests tab');
        setUyari(true);
        history.push('Tests');
        return;
      }

      if (MerkezeGonderilecekData[0].UpgradeSonucNotu == '' || islemYeri == 0 || sourceOfDefect == 0) {
        setLoadingControl(false);
        setClosePopupControl(false);
        setUyariTip('error');
        setUyariAciklama(t('lblFinalNoteError'));
        setUyari(true);
        return;
      }
      const storedValue = localStorage.getItem('ExchangeSaved' + ReceiptNo);
      if ((storedValue && storedValue === "false") && MerkezeGonderilecekData[0].ChangeReason > 0) {
        setLoadingControl(false);
        setClosePopupControl(false);
        setUyariTip('error');
        setUyariAciklama(t('lblExchangeNotSave'));
        setUyari(true);
        return;
      }

      setClosePopupControl(false);
      axios.post('/SetWorkOrderUpdate', data, config)
        .then((response) => {
          setLoadingControl(false);
          setClosePopupControl(false);
          const ResponseData = response.data[0];
          if (parseInt(ResponseData.ErrorCode) !== 0) {
            setUyariTip('error');
            setUyariAciklama(ResponseData.ErrorDescription);
          } else {
            setUyariTip('success');
            setUyariAciklama(ResponseData.ErrorDescription);
            setReadonly(true);
            let job = loadBaslandiJob()[0];
            job = {
              ...job,
              StatusCode: sonDurum || 0,
              Status: sonDurumAciklama || t('Son_Durum'),
              StatusCodeSearch: sonDurum || 0,
            };
            setTask(job);
            removeBaslandiJob();
            // dispatch(resetModel());
            if (selectedMobileStatus == 8 || selectedMobileStatus == 49 && SatisfactionRate == 0) {
              setRating(true);
            }
            if (ResponseData?.OrderId > 0) {
              setMaterialOrderId(ResponseData?.OrderId);
              isCancelledRef.current = false;
              setOpenMaterialOrder(true);
            } else {
              setMaterialOrderId(0);
              setOpenMaterialOrder(false);
            }


          }
          setUyari(true);
        }).catch((error) => {
          setLoadingControl(false);
          setClosePopupControl(false);
          setUyariTip('error');
          setUyariAciklama(t('Error') + error.message);
          setUyari(true);
        });

    } catch (error) {
      setClosePopupControl(false);
      setLoadingControl(false);
      setUyariTip('error');
      setUyariAciklama(t('Error') + error.message);
      setUyari(true);
    }

  };

  useEffect(() => {
    if (!isOnline) {
      setUyariTip('error');
      setUyari(true);
      setUyariAciklama(t('Offline_Message'));
    }
    else {
      setUyari(false);
    }
  }, [isOnline])

  function SaveRating() {
    const dataBody = {
      WorkOrderId: ReceiptNo,
      SatisfactionRate: SatisfactionRate,
    };

    const dataConfig = {
      headers: { 'Content-Type': 'application/json' }
    };
    if (SatisfactionRate == 0 || SatisfactionRate == null || SatisfactionRate == undefined) {
      setLoadingControl(false);
      setClosePopupControl(false);
      setUyariTip('error');
      setUyariAciklama(t('lblSatisfactionMustChoose'));
      setUyari(true);
      return;
    }
    axios
      .post('/SetConsumerSatisfactionRate', dataBody, dataConfig)
      .then(response => {
        const ResponseData = response.data[0];
        if (parseInt(ResponseData.ErrorCode) !== 0) {
          setUyariTip('error');
          setUyariAciklama(ResponseData.ErrorDescription);
          setUyari(true);
          setRating(false);
        } else {
          setUyariTip('success');
          setUyariAciklama(ResponseData.ErrorDescription);
          setUyari(true);
          setRating(false);
        }
      })
      .catch(error => {
        setUyariAciklama(t('Error') + error.message);
        setUyariTip('error');
        setUyari(true);
        setRating(false);
      });
  }

  function funcRatingValue(ratingValue) {
    setSatisfactionRate(ratingValue);
  }

  function GetMaterialOrderSAPCountry() {
    axios
      .post('/GetMaterialOrderSAPCountry/' + SessionUser.TenantId)
      .then(response => {
        if (response.data) {
          if (OrderNr !== '' && OrderNr !== undefined) {
            CreateOrderInSap(OrderNr);
          } else {
            CreateOrderInSap(MaterialOrderId);
          }
        }
      });
  }

  function CreateOrderInSap(MaterialOrderId) {
    axios
      .post('/CreateOrderInSAP/' + MaterialOrderId)
      .then(response => {
        if (response.data[0]?.ErrorCode == 1000) {
          setresponseMessage({
            ErrorCode: response.data[0]?.ErrorCode,
            ErrorDescription: response.data[0]?.ErrorDescription
          });
          setUyariTip('error');
          setUyari(true);
          setOpen(true);
          setUyari1(responseMessage.ErrorDescription);
          return;
        } else {
          setresponseMessage({
            ErrorCode: 0,
            ErrorDescription: t('sendSapSuccess')
          });
          setUyariTip('success');
          setUyari(true);
          setOpen(true);
          setUyari1(responseMessage.ErrorDescription);
        }
      });
  }

  function handleCloseDialog(event, reason) {
    if (reason && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
      setUyariTip('warning');
      setUyari(true);
      setOpen(true);
      setUyari1(t('lblWarningMessage'));
      return;
    }

    setOpenMaterialOrder(false);
    if (SessionUser.TenantId != 64 && !isCancelledRef.current) {
      GetMaterialOrderSAPCountry();
    }
  }

  async function AIPrediction() {
    setLoadingControl(true);
    var row = SonlandirData[0];

    const predictionRequest = {
      BASVURU_NEDENI: row.IssueReason,
      BASVURU_NOTU: row.CallCenterNote === null ? '' : row.CallCenterNote,
      FIS_NO: row.ReceiptNo,
      MODEL_KODU: row.MappingModelCode,
      SF_ACIKLAMA: ""
    };

    axiosHeadOffice
      .post('/AIPrediction', predictionRequest)
      .then(result => {
        var response = result.data.Response;
        var responsePredictions = result.data.TAHMINLER;

        if (response.ErrorCode !== '1000') {
          setPredictions(responsePredictions);
          AIDefectsAndMaterials(responsePredictions);
        }
      });
    setLoadingControl(false);
  }

  async function AIDefectsAndMaterials(predictions) {
    setDefectsAndMaterials([]);
    setLoadingControl(true);

    const DefectCodes = predictions.map(p => p.HIZMET_KODU);
    const MaterialCodes = predictions.map(p => p.MALZEME_KODU);

    const data = {
      HIZMET_KODU: DefectCodes,
      MALZEME_KODU: MaterialCodes
    };

    axiosHeadOffice
      .post('/GetAIPredictionDefectAndMaterial', data)
      .then(values => {
        if (values.data?.length > 0) {
          var filteredData = values.data;
          setDefectsAndMaterials(filteredData.map((d) => ({
            DefectId: d.DefectId,
            DefectCode: d.DefectCode,
            Defect: d.Defect,
            CategoryLevel2: d.CategoryLevel2,
            DefectType: d.DefectType,
            DefectTypeCode: d.DefectTypeCode,
            MaterialId: d.MaterialId,
            MaterialCode: d.MaterialCode,
            MaterialDsc: d.MaterialDsc
          })));
        } else {
          setDefectsAndMaterials([]);
        }
      });
    setLoadingControl(false);
  }

  const checkIfTomorrow = (appointmentDate) => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);

    const appointment = new Date(appointmentDate);

    return (
      appointment.getDate() === tomorrow.getDate() &&
      appointment.getMonth() === tomorrow.getMonth() &&
      appointment.getFullYear() === tomorrow.getFullYear()
    );
  };

  function TriagePreorderOperations(isOrder) {
    const isTomorrow = checkIfTomorrow(SonlandirData.find(x => x.ReceiptNo === ReceiptNo).AppointmentDate);

    if (isOrder && isTomorrow) { //If appointment date is tomorrow, we cannot create an order.
      setOpen1(true);
      setUyari1(t('lblNotOrder'));
      return;
    } else { // other situations; isorder false or isorder true and appointment date is not tomorrow.
      setLoadingControl(true);
      const data = matchedPairs.length > 0 ? matchedPairs.map(pair => ({
        WorkOrderId: ReceiptNo.includes(" ") ? ReceiptNo.trim() : ReceiptNo,
        DefectId: pair.defect.DefectId,
        MaterialId: pair.material.MaterialId,
        IsOrder: isOrder,
        EmployeeId: SessionUser.TechnicianId
      })) :
        [{
          WorkOrderId: ReceiptNo.includes(" ") ? ReceiptNo.trim() : ReceiptNo,
          DefectId: 0,
          MaterialId: 0,
          IsOrder: isOrder,
          EmployeeId: SessionUser.TechnicianId
        }];


      axiosHeadOffice
        .post('/TriagePreorderOperations', data)
        .then(response => {
          if (response.data.ErrorCode === "0") {
            setOpen(true);
            setUyari1(t('lblSuccess') + ' - ' + response.data.ErrorDescription);
            setOpenAIDialog(false);
            // getTasksRequest(parseInt(SonlandirData[0].ReceiptNo));
          }
          else if (response.data.ErrorCode === "10") {
            setOpen(true);
            setUyari1(isOrder ? t('lblTriageOperationMsg') : t('lblWithoutOrderTip'));
            setOpenAIDialog(false);
            // getTasksRequest(parseInt(SonlandirData[0].ReceiptNo));
          }
          else if (response.data.ErrorCode === "1000") {
            setOpen(true);
            setUyari1(response.data.ErrorDescription);
          }
        });
      if (isOrder) {
        setOpenTriageMaterialOrder(true);
      }
      setLoadingControl(false);
    }
  }

  const handleDefectSelect = (defect) => {
    setSelectedDefect(defect);
    setSelectedMaterial(null);
  };

  const handleMaterialSelect = (material) => {
    setSelectedMaterial(material);
  };

  const handleMatch = () => {
    if (selectedDefect && selectedMaterial) {
      setMatchedPairs([...matchedPairs, { defect: selectedDefect, material: selectedMaterial }]);
      setSelectedDefect(null);
      setSelectedMaterial(null);
    }
  };

  const handleDeleteMatchedPair = (index) => {
    const updatedMatchedPairs = [...matchedPairs];
    updatedMatchedPairs.splice(index, 1);
    setMatchedPairs(updatedMatchedPairs);
  };


  function GetDefectsAndMaterialsByWorkOrderId() {
    setLoadingControl(true);

    axiosHeadOffice
      .get('/GetDefectsAndMaterialsByWorkOrderId/' + ReceiptNo)
      .then(response => {
        if (response.data.length > 0) {
          setDefectAndMaterialList(response.data);
        } else {
          setDefectAndMaterialList([]);
        }
      });
    setLoadingControl(false);
  }

  useEffect(() => {
    if (OpenAIDialog === true)
      GetDefectsAndMaterialsByWorkOrderId();
  }, [OpenAIDialog]);


  function handleAddMatchedPairs(newDefect, newMaterial) {
    if (newDefect !== undefined) {
      setMatchedPairs([...matchedPairs, {
        defect: { Defect: newDefect.DefectDesc, DefectCode: newDefect.UserCode, DefectId: newDefect.Code },
        material: { MaterialCode: newMaterial.MaterialCode, MaterialDsc: newMaterial.MaterialDesc, MaterialId: newMaterial.MaterialId }
      }]);
    }
  }

  const hasMaterialAndDefect = matchedPairs.some(pair => pair.material && pair.defect);

  const getOrderNr = (orderNr) => {
    if (orderNr !== undefined) {
      setOrderNr(orderNr);
    }
  };

  const handleCloseTriageMaterialOrder = () => {
    if (OrderNr === '' || OrderNr === undefined) {
      setOpen(true);
      setUyari1(t('lblObligationOrderMsg'));
    } else {
      setOpenTriageMaterialOrder(false);
      GetMaterialOrderSAPCountry();
    }
  };

  return (
    <>
      <Card className={clsx(classes.root, className)}>
        <CardHeader title={t('Sonlandir')} />
        <Divider />
        {
          uyari
            ? <Alert onClose={uyariKapat} open={uyari} message={uyariAciklama || ''} variant={uyariTip} />
            : <div />
        }
        <CardContent className={classes.content}>
          <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <DialogTitle id="alert-dialog-slide-title" color="primary">{t('Bilgilendirme')}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-slide-description">
                {Uyari1}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpen(false)} color="primary">
                {t('Tamam')}
              </Button>
            </DialogActions>
          </Dialog>
          {
            LoadingControl
              ? (
                <CircularProgress
                  status="loading"
                  style={{ marginLeft: '50%' }}
                />
              )
              : (
                <form className={clsx(classes.root, className)} onSubmit={handleSubmit}>
                  <div className={classes.fields}>
                    <FormControl variant="outlined" className={classes.formControl}>
                      <InputLabel id="demo-simple-select-outlined-label" disabled={readonly}>{t('Durum')}</InputLabel>
                      <Select
                        fullWidth
                        native
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        onChange={handleChangeDurum}
                        label={t('Durum')}
                        disabled={!isOnline ? true : readonly}
                        value={sonDurum || 0}
                      >
                        <option key={0} value={0}></option>
                        {StatusData.map((p) => <option key={p.StatusId} value={p.StatusId}>{p.FieldText}</option>)}
                      </Select>
                    </FormControl>
                  </div>
                  <div className={classes.fields}>
                    <FormControl variant="outlined" className={classes.formControl}>
                      <InputLabel id="demo-simple-select-outlined-label" disabled={readonly}>
                        {t('islem_Yeri')}
                        {islemYeri == 0 && <span> *</span>}
                      </InputLabel>
                      <Select
                        fullWidth
                        native
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        onChange={handleChangeIslemYeri}
                        label={t('islem_Yeri')}
                        disabled={!isOnline ? true : readonly}
                        value={islemYeri || 0}
                        error={islemYeri > 0 ? false : Required}
                      >
                        <option key={0} value={0}></option>
                        {PlaceData.map((p) => <option key={p.Id} value={p.Id}>{p.Dsc}</option>)}
                      </Select>
                    </FormControl>
                  </div>
                  <div className={classes.fields}>
                    <FormControl variant="outlined" className={classes.formControl}>
                      <InputLabel id="demo-simple-select-outlined-label" disabled={readonly}>
                        {t('lblPleaseChooseDefect')}
                        {sourceOfDefect == 0 && <span> *</span>}
                      </InputLabel>
                      <Select
                        fullWidth
                        native
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        onChange={(event) => {
                          setSourceOfDefect(event.target.value)
                        }}
                        label={t('lblSourceOfDefect')}
                        disabled={!isOnline ? true : readonly}
                        value={sourceOfDefect || 0}
                        error={sourceOfDefect > 0 ? false : Required}
                      >
                        <option key={0} value={0}></option>
                        {sourceOfDefectData.map((p) => <option key={p.Id} value={p.Id}>{p.Dsc}</option>)}
                      </Select>
                    </FormControl>
                  </div>
                  <div className={classes.fields}>
                    <FormControl variant="outlined" className={classes.formControl}>
                      <InputLabel id="demo-simple-select-outlined-label" disabled={readonly}>{t('Tahsilat_Tipi')}</InputLabel>
                      <Select
                        fullWidth
                        native
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        onChange={handleChangeTahsilatTipi}
                        label={t('Tahsilat_Tipi')}
                        disabled={!isOnline ? true : readonly}
                        hidden
                        value={tahsilatTipi}
                      >
                        <option key={0} value={0}></option>
                        {PaymentTypeData.map((p) => <option key={p.Id} value={p.Id}>{p.Dsc}</option>)}
                      </Select>
                    </FormControl>
                  </div>
                  <div className={classes.fields}>
                    <TextField
                      label={t('lblPaymentDetail')}
                      name="PaymentDetail"
                      multiline
                      fullWidth
                      value={PaymentDetail}
                      onChange={handleChangePaymentDetail}
                      variant="outlined"
                      disabled={!isOnline ? true : readonly}
                    />
                  </div>
                  <div className={classes.fields}>
                    <FormControl variant="outlined" className={classes.formControl}>
                      <InputLabel id="demo-simple-select-outlined-label" disabled={!isOnline ? true : readonly}>{t('lblReworkStatus')}</InputLabel>
                      <Select
                        fullWidth
                        native
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        onChange={handleChangeRework}
                        label={t('lblReworkStatus')}
                        disabled={!isOnline ? true : readonly}
                        hidden
                        value={reworkDurum}
                      >
                        <option key={0} value={0}></option>
                        {ReworkData.map((p) => <option key={p.Id} value={p.Id}>{p.Dsc}</option>)}
                      </Select>
                    </FormControl>
                  </div>
                  <div className={classes.fields}>
                    <FormControl variant="outlined" className={classes.formControl}>
                      <InputLabel id="demo-simple-select-outlined-label" disabled={!isOnline ? true : readonly}>{t('lblRefurbishmentGrade')}</InputLabel>
                      <Select
                        fullWidth
                        native
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        onChange={handleChangeRefurbishment}
                        label={t('lblRefurbishmentGrade')}
                        disabled={!isOnline ? true : WarrantyTypeId[0]?.WarrantyGroupId !== 13}
                        hidden
                        value={RefurbishmentId}
                      >
                        <option key={0} value={0}></option>
                        {RefurbishmentData.map((p) => <option key={p.Id} value={p.Id}>{p.Grade}</option>)}
                      </Select>
                    </FormControl>
                  </div>
                  {RefurbishmentStorageLocationData && RefurbishmentStorageLocationData.length > 1 && (
                    <div className={classes.fields}>
                      <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel id="demo-simple-select-outlined-label" disabled={readonly}>{t('lblRefurbishment')}</InputLabel>
                        <Select
                          fullWidth
                          native
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          onChange={handleChangeRefurbishmentStorageLocation}
                          label={t('lblRefurbishment')}
                          disabled={WarrantyTypeId[0]?.WarrantyGroupId !== 13}
                          hidden
                          value={RefurbishmentStorageLocationId}
                        >
                          <option key={0} value={0}></option>
                          {RefurbishmentStorageLocationData.map((p) => <option key={p.Id} value={p.Id}>{p.Code}</option>)}
                        </Select>
                      </FormControl>
                    </div>
                  )}

                  <div className={classes.fields}>
                    <TextField
                      label={t('Proje_Kodu')}
                      name="ProjeKodu"
                      multiline
                      fullWidth
                      value={ProjeKodu}
                      onChange={handleChangeProjeKodu}
                      variant="outlined"
                      disabled={!isOnline ? true : readonly}
                    />
                  </div>
                  <div className={classes.fields}>
                    <TextField
                      label={t('Sonuc_Notu')}
                      name="SonucNotu"
                      multiline
                      required={SonucNotu == '' ? true : false}
                      error={SonucNotu > 0 ? false : Required}
                      rows={4}
                      fullWidth
                      value={SonucNotu}
                      onChange={handleChangeSonucNotu}
                      variant="outlined"
                      disabled={!isOnline ? true : readonly}
                      inputProps={{ maxLength: 2000 }}
                    />
                    {
                      openLegal
                        ? (
                          <Alert
                            variant="warning"
                            open={openLegal}
                            message={t('saglik_bilgisi_warning')}
                            onClose={handleCloseopenLegal}
                          />
                        )
                        : <div />
                    }
                  </div>
                  <div className={classes.fields}>
                    <Typography className={classes.title} color="textSecondary" gutterBottom>
                      {t('Garanti_tip')}
                      {' '}
                      <b style={{ color: colors.red[300] }}>{SonlandirData ? SonlandirData[0]?.WarrantyTypeText : ''}</b>
                    </Typography>
                    {WarrantyTypeId[0]?.WarrantyGroupId === 2 ?
                      <Typography
                        className={classes.title}
                        color="textSecondary"
                        gutterBottom
                      >
                        {('Payment Status')}{' '}
                        <b style={{ color: colors.red[300] }}>
                          Awaiting
                        </b>
                      </Typography>
                      : ''}
                  </div>
                  {SonlandirData[0].PriceVisible ? <>
                    <div className={classes.fields}>
                      <Typography className={classes.title} align="right" color="textSecondary" gutterBottom>
                        {t('iscilik_Toplami')}
                        {' '}
                        <b>
                          {`${moneyFormat(currLabourVatSum, SessionUser.TenantCode, SessionUser.CurrencyUnit)} ${SessionUser.CurrencyUnit}`}
                          {' '}
                        </b>
                      </Typography>
                    </div>
                    <div className={classes.fields}>
                      <Typography className={classes.title} align="right" color="textSecondary" gutterBottom>
                        {t('malzeme_Toplami')}
                        {' '}
                        <b>
                          {`${moneyFormat(currMaterialVatSum, SessionUser.TenantCode, SessionUser.CurrencyUnit)} ${SessionUser.CurrencyUnit}`}
                          {' '}
                        </b>
                      </Typography>
                    </div>
                    <div className={classes.fields}>
                      <Typography className={classes.title} align="right" color="textSecondary" gutterBottom>
                        {t('yol_Toplami')}
                        {' '}
                        <b>
                          {`${moneyFormat(currTransportVatSum, SessionUser.TenantCode, SessionUser.CurrencyUnit)} ${SessionUser.CurrencyUnit}`}
                          {' '}
                        </b>
                      </Typography>
                    </div>
                    <div className={classes.fields}>
                      <Typography className={classes.title} align="right" color="textSecondary" gutterBottom>
                        {t('lblExtraPrice')}
                        {' '}
                        <b>
                          {`${moneyFormat(currExtraVatSum, SessionUser.TenantCode, SessionUser.CurrencyUnit)} ${SessionUser.CurrencyUnit}`}
                          {' '}
                        </b>
                      </Typography>
                    </div>
                  </> : ''}

                  <div className={classes.fields}>
                    <Typography className={classes.title} align="right" style={{ color: 'red' }} color="textSecondary" gutterBottom>
                      {t('lblVatTotal')}
                      {' '}
                      <b>
                        {
                          SonlandirData[0].PriceVisible ?
                            isPosTenantVat
                              ? `${moneyFormat(
                                  Math.round(currMaterialVatSum * 100) / 100
                                  + Math.round(currLabourVatSum * 100) / 100
                                  + Math.round(currTransportVatSum * 100) / 100
                                  + Math.round(currExtraVatSum * 100) / 100
                                , SessionUser.TenantCode, SessionUser.CurrencyUnit)} ${SessionUser.CurrencyUnit}`
                              : `${moneyFormat((currMaterialSum + currLabourSum + currTransportSum + currExtraSum)
                                  -
                                  ((currMaterialSum + currLabourSum + currTransportSum + currExtraSum)
                                    -
                                    (currMaterialVatSum + currLabourVatSum + currTransportVatSum + currExtraVatSum))
                                  , SessionUser.TenantCode, SessionUser.CurrencyUnit)} ${SessionUser.CurrencyUnit}`
                            :
                            `${moneyFormat((currTransportSum + currExtraSum)
                              -
                              ((currTransportSum + currExtraSum)
                                -
                                (currTransportVatSum + currExtraVatSum))
                              , SessionUser.TenantCode, SessionUser.CurrencyUnit)} ${SessionUser.CurrencyUnit}`
                        }
                        {' '}
                      </b>
                    </Typography>
                  </div>
                  <div className={classes.fields}>
                    <Typography className={classes.title} align="right" style={{ color: 'red' }} color="textSecondary" gutterBottom>
                      {t('lblVat')}
                      {' '}
                      <b>
                        {SonlandirData[0].PriceVisible ?
                          isPosTenantVat
                            ? `${moneyFormat(
                                (() => {
                                  const vatTotal = Math.round(currMaterialSum * 100) / 100 + Math.round(currLabourSum * 100) / 100 + Math.round(currTransportSum * 100) / 100 + Math.round(currExtraSum * 100) / 100;
                                  const base = Math.round(vatTotal / (1 + posTenantVatRateValue) * 100) / 100;
                                  return Math.round((vatTotal - base) * 100) / 100;
                                })()
                              , SessionUser.TenantCode, SessionUser.CurrencyUnit)} ${SessionUser.CurrencyUnit}`
                            : `${moneyFormat(
                                (currMaterialSum + currLabourSum + currTransportSum + currExtraSum)
                                -
                                (currMaterialVatSum + currLabourVatSum + currTransportVatSum + currExtraVatSum)
                                , SessionUser.TenantCode, SessionUser.CurrencyUnit)} ${SessionUser.CurrencyUnit}`
                          :
                          `${moneyFormat(
                            (currTransportSum + currExtraSum)
                            -
                            (currTransportVatSum + currExtraVatSum)
                            , SessionUser.TenantCode, SessionUser.CurrencyUnit)} ${SessionUser.CurrencyUnit}`
                        }
                        {' '}
                      </b>
                    </Typography>
                  </div>
                  <div className={classes.fields}>
                    <Typography className={classes.title} align="right" style={{ color: 'red' }} color="textSecondary" gutterBottom>
                      {t('Toplam')}
                      {' '}
                      <b>
                        {SonlandirData[0].PriceVisible ?
                          isPosTenantVat
                            ? `${moneyFormat(
                                Math.round(currMaterialSum * 100) / 100
                                + Math.round(currLabourSum * 100) / 100
                                + Math.round(currTransportSum * 100) / 100
                                + Math.round(currExtraSum * 100) / 100
                              , SessionUser.TenantCode, SessionUser.CurrencyUnit)} ${SessionUser.CurrencyUnit}`
                            : `${moneyFormat((currMaterialSum + currLabourSum + currTransportSum + currExtraSum), SessionUser.TenantCode, SessionUser.CurrencyUnit)} ${SessionUser.CurrencyUnit}`
                          :
                          `${moneyFormat((currTransportSum + currExtraSum), SessionUser.TenantCode, SessionUser.CurrencyUnit)} ${SessionUser.CurrencyUnit}`
                        }
                        {' '}
                      </b>
                    </Typography>
                  </div>
                  <br />
                  {
                    (
                      (
                        (SonlandirData[0]?.WorkOrderMaterials !== undefined && SonlandirData[0]?.WorkOrderMaterials?.length > 0
                          ||
                          SonlandirData[0]?.WorkOrderLabours !== undefined && SonlandirData[0]?.WorkOrderLabours?.length > 0)
                      )
                      &&
                      (
                        discountParams.some(d => d.WarrantyGroupId === SonlandirData[0]?.WarrantyGroupId
                          && d.ServiceShopTypeId === SonlandirData[0]?.ServiceShopType)
                      )
                    ) ?
                      <div>
                        <Grid item xs={12} align="right">
                          <Grid item xs={6} align="right" />
                          <Grid item xs={6} align="left">
                            <div className={classes.fields}>
                              <div className={classes.fields}>
                                <FormControl variant="outlined" className={classes.formControl}>
                                  <TextField
                                    size="small"
                                    fullWidth
                                    select
                                    label={t('lblDiscountType')}
                                    id="DiscountTypeId"
                                    onChange={handleChangeDiscountType}
                                    value={DiscountTypeId || ''}
                                    variant="outlined"
                                    disabled={!isOnline ? true : readonly}
                                  >
                                    {SonlandirData[0].DiscountTypes.map(p => {
                                      return (
                                        <MenuItem key={p.Id} value={p.Id}>
                                          {p.Dsc}
                                        </MenuItem>
                                      );
                                    })}
                                  </TextField>
                                </FormControl>
                              </div>
                              <div className={classes.fields}>
                                <FormControl variant="outlined" className={classes.formControl}>
                                  <TextField
                                    size="small"
                                    fullWidth
                                    select
                                    label={t('lblDiscountRates')}
                                    id="DiscountRateId"
                                    onChange={handleChangeDiscountRate}
                                    value={DiscountRateId || ''}
                                    variant="outlined"
                                    disabled={!isOnline ? true : readonly}
                                  >
                                    {SonlandirData[0].DiscountRates.filter(r => r.DiscountTypeId === DiscountTypeId).map(p => {
                                      return (
                                        <MenuItem key={p.Id} value={p.Id}>
                                          %{p.Rate}
                                        </MenuItem>
                                      );
                                    })}
                                  </TextField>
                                </FormControl>
                              </div>
                            </div>
                          </Grid>
                        </Grid>
                      </div>
                      : <div />
                  }
                  <div className={classes.fields}>
                    {isOnline && (
                      <Button
                        variant="contained"
                        color="primary"
                        // YE bhi hamara hi kam hai i guess coment karida hai usne tw 
                        //send to satisfactionrate() kahan ayega ye dekh lena ok

                        // onClick={(event) => handleMerkezeGonder(event, 0)} //apna kam yad rakho bus bhej ra hoon voice 
                        onClick={() => sendToSatisfactionRate()}
                        disabled={!isOnline || readonly}
                        className={classes.submitButton}
                        endIcon={<SendIcon />}
                      >
                        {t('Merkeze_Gonder')}
                      </Button>
                    )}
                    {SessionUser.TenantId === 46 && !isOnline && (
                      <Button
                        variant="contained"
                        color="primary"
                        // YE bhi hamara hi kam hai i guess coment karida hai usne tw 
                        //send to satisfactionrate() kahan ayega ye dekh lena ok

                        // onClick={(event) => handleMerkezeGonder(event, 0)} //apna kam yad rakho bus bhej ra hoon voice 
                        onClick={() => sendRepairCompletedDate()}
                        disabled={readonly}
                        className={classes.submitButton}
                        endIcon={<SendIcon />}
                      >
                        {t('lblRepairCompleted')}
                      </Button>
                    )}
                    {SessionUser.TenantId === 16 && (
                      <Button
                        variant="contained"
                        color="primary"
                        // YE bhi hamara hi kam hai i guess coment karida hai usne tw 
                        //send to satisfactionrate() kahan ayega ye dekh lena ok

                        // onClick={(event) => handleMerkezeGonder(event, 0)} //apna kam yad rakho bus bhej ra hoon voice 
                        onClick={() => handleMakeBookingButtonOnClick()}
                        disabled={!isOnline || !bookableStates.some(state => state.Id === SonlandirData[0]?.StatusCode)}
                        className={classes.submitButton}
                        endIcon={<SendIcon />}
                      >
                        {t('lblMakeBooking')}
                      </Button>
                    )}
                    {PayButtonActive && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleOpenPaymentDialog}
                        disabled={!isOnline || readonly}
                        className={classes.submitButton}
                        startIcon={<CreditCardIcon />}
                      >
                        {t('Payment')}
                      </Button>
                    )}
                    <br />
                    <br />
                    <br />
                    <br />
                  </div>
                </form>
              )
          }
        </CardContent>
        {/* {!readonly && !LoadingControl && <SonlandirOzet />} */}
      </Card>
      <ChecklistDialog
        open={checklistOpen}
        onClose={() => setChecklistOpen(false)}
        items={checklistItems}
        onSave={handleChecklistSave}
        title={checklistTitle}
        confirmText={checklistConfirmText}
        sendButtonLabel={t('lblSend')}
        cancelButtonLabel={t('lblCancel')}
      />
      <Dialog
        fullScreen
        open={open1}
        onClose={() => setOpen1(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        {loading ? (
          <CircularProgress
            status="loading"
            style={{ marginLeft: '50%' }}
          />
        )
          : <div />}
        <DialogTitle id="alert-dialog-title">
          {MusteriBilgileri}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography variant="body2" color="textSecondary" gutterBottom>
              {t('Basvuru_Nedeni')}
            </Typography>
            <Typography variant="h6" component="h2">
              <AppReasonSearch
                setIssue={setIssue}
                value={{
                  Dsc: IssueIdNewData.IssueReason || '',
                  Id: IssueIdNewData.IssueId || 0,
                } || ''}
                searchParam={search}
              />
              <br />
            </Typography>
            <Typography>
              <ThemeProvider theme={materialTheme}>
                <MuiPickersUtilsProvider
                  utils={DateFnsUtils}
                  locale={localeMap[locale]}
                >
                  <KeyboardDateTimePicker
                    color="primary"
                    fullWidth
                    size="small"
                    ampm={false}
                    inputVariant="outlined"
                    id="WarrantyDate"
                    label={t('lblAppointmentDate')}
                    invalidDateMessage={t('hatali_tarih')}
                    format="dd.MM.yyyy HH.mm"
                    variant="outlined"
                    value={NewAppointment}
                    onChange={e => setAppointmentData(e)}
                    KeyboardButtonProps={{
                      'aria-label': 'change date'
                    }}
                  />
                </MuiPickersUtilsProvider>
              </ThemeProvider>


            </Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={(event) => handleMerkezeGonder(event, 0)}
            disabled={loading}
            className={classes.button}
            endIcon={<AddIcon />}
          >
            {t('Olustur')}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpen1(false)}
            className={classes.button}
            endIcon={<CloseIcon />}
          >
            {t('iptal')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={ClosePopupControl}
        onClose={() => {
          setClosePopupControl(false);
          clearUnusedItemsCheckBox()
        }}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          <Typography variant="h5" component="h2">
            {ClosePopupHeader}
          </Typography>
        </DialogTitle>
        <DialogActions>
          <Button
            variant="contained"
            onClick={(event) => {
              handleMerkezeGonderEvet(event, CloseTypePopupControl1);
              clearUnusedItemsCheckBox()
            }}
            color="primary">
            {CloseBtn1}
          </Button>
          <Button
            variant="contained"
            onClick={(event) => {
              handleMerkezeGonderEvet(event, CloseTypePopupControl2);
              clearUnusedItemsCheckBox()
            }}
            color="primary">
            {CloseBtn2}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={OpenMaterialOrder}
        fullWidth
        fullScreen
        onClose={handleCloseDialog}
        disableBackdropClick
        disableEscapeKeyDown
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >

        <DialogContent>
          <ForPartner MaterialOrderIdPopup={MaterialOrderId} onCancel={() => { isCancelledRef.current = true; }} onSapSent={() => { isCancelledRef.current = true; }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenCloseConfirm(true)} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openCloseConfirm}
        onClose={() => setOpenCloseConfirm(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title" color="primary">
          {t('lblInfo')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {t('lblConfirmClose')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => {
            setOpenCloseConfirm(false);
            handleCloseDialog(e);
          }} color="primary" autoFocus>
            {t('lblYes')}
          </Button>
          <Button onClick={() => setOpenCloseConfirm(false)} color="primary">
            {t('lblNo')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={OpenTriageMaterialOrder}
        fullWidth={true}
        maxWidth={'xl'}
        onClose={() => handleCloseTriageMaterialOrder()}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <TriageMaterialOrder
            MaterialIds={matchedPairs.map(p => p.material?.MaterialId)}
            WorkOrderId={ReceiptNo.includes(" ") ? ReceiptNo.trim() : ReceiptNo}
            ServiceShopId={SonlandirData[0]?.ServiceShopId}
            getOrderNr={getOrderNr}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseTriageMaterialOrder()} color="primary">
            <CloseIcon />
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={rating}
        fullWidth
        onClose={() => setRating(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <SatisfactionRating funcRatingValue={funcRatingValue} />
        </DialogContent>
        <DialogActions>
          <Button className={classes.button} onClick={SaveRating} color="primary">
            {t('lblSave')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={OpenUsedNotUsedDialog}
        fullWidth={true}
        maxWidth={'xl'}
        onClose={() => { setOpenUsedNotUsedDialog(false); clearUnusedItemsCheckBox() }}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          {error && <Grid item xs={6} md={12} style={{ backgroundColor: "#1d3343", padding: "6px 14px" }}>
            <Typography variant="h6" gutterBottom style={{ color: "white" }}>
              You have to select all items!
            </Typography>
          </Grid>}

          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Defect Name</TableCell>
                  <TableCell align="left">Material </TableCell>
                  <TableCell align="left">Used</TableCell>
                  <TableCell align="left">Not Used</TableCell>
                </TableRow>
              </TableHead>
              {cloneArray?.map((row, index) => {
                return (<TableRow key={index}>
                  <TableCell align="left">
                    <Typography>
                      {row.DefectDesc}
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography>
                      {row.MaterialCode} - {row.MaterialDesc}
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    <FormControlLabel control={<Checkbox checked={row.is_selected} onChange={(e) => { checkSelection({ index, value: true, id: row.MaterialId }) }} />} />
                  </TableCell>
                  <TableCell align="left">
                    <FormControlLabel control={<Checkbox checked={row.is_selected !== null && !row.is_selected} onChange={(e) => { checkSelection({ index, value: false, id: row.MaterialId }) }} />} /></TableCell>
                </TableRow>)
              })}
            </Table>
          </TableContainer>

        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setOpenUsedNotUsedDialog(false); clearUnusedItemsCheckBox() }} color="primary">
            Cancel {/* {t('Tamam')} */}
          </Button>
          <Button onClick={() => handleSelectedUnusedItems()} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={OpenAIDialog}
        onClose={() => setOpenAIDialog(false)}
        fullWidth
        maxWidth="xl"
        style={{ width: '100%', height: '100%' }}
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {t('lblAIPredictions')}
        </DialogTitle>
        <DialogContent>
          <React.Fragment>
            <Grid container spacing={2}>
              <Grid item xs={5}>
                <Typography variant="h6">{t('lblDefects')}</Typography>
                {defectsAndMaterials.map((defect, index) => (
                  defect.DefectCode && defect.Defect && (
                    <Paper key={index} style={{ padding: '10px', marginBottom: '10px' }}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={8}>
                          <Typography>{`${defect.CategoryLevel2 + ', ' + defect.DefectType + ' - ' + defect.Defect}`}</Typography>
                        </Grid>
                        <Grid item xs={4} style={{ textAlign: 'right' }}>
                          <FormControlLabel
                            control={<Checkbox color="primary" />}
                            label=""
                            checked={selectedDefect === defect}
                            onChange={() => handleDefectSelect(defect)}
                          />
                        </Grid>
                      </Grid>
                    </Paper>
                  )
                ))}
              </Grid>
              <Grid item xs={2}>
                {/* Match button */}
                <Grid container spacing={2} direction="column" alignItems="center">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleMatch}
                    disabled={!selectedDefect || !selectedMaterial}
                  >
                    {t('lblMatch')}
                  </Button>
                </Grid>
              </Grid>
              <Grid item xs={5} style={{ flexBasis: '40%' }}>
                <Typography variant="h6">{t('lblMaterials')}</Typography>
                {defectsAndMaterials.map((material, index) => (
                  material.MaterialCode && material.MaterialDsc && (
                    <Paper key={index} style={{ padding: '10px', marginBottom: '10px' }}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={8}>
                          <Typography>{`${material.MaterialCode}-${material.MaterialDsc}`}</Typography>
                        </Grid>
                        <Grid item xs={4} style={{ textAlign: 'right' }}>
                          <FormControlLabel
                            control={<Checkbox color="primary" />}
                            label=""
                            checked={selectedMaterial === material && selectedDefect}
                            onChange={() => handleMaterialSelect(material)}
                            disabled={matchedPairs.some(pair => pair.material?.MaterialCode === material.MaterialCode) || !selectedDefect}
                          />
                        </Grid>
                      </Grid>
                    </Paper>
                  )
                ))}
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <Card>
                <DefectTriage matchedPairsArray={matchedPairs ? matchedPairs : []} handleAddMatchedPairs={handleAddMatchedPairs} ReceiptNo={ReceiptNo} readonly={false} />
              </Card>
            </Grid>
            <Divider style={{ margin: '20px 0' }} />
            <Typography variant="h6">{t('lblAlreadyUsed')}</Typography>
            {defectAndMaterialList.map((pair, index) => (
              <React.Fragment key={index}>
                <Grid container alignItems="center">
                  <Grid item xs={1}>
                    <ChevronRightIcon />
                  </Grid>
                  <Grid item xs={9}>
                    <Typography>{pair ? `${pair.Defect} | ${pair.Material}` : ''}</Typography>
                  </Grid>
                </Grid>
              </React.Fragment>
            ))}
            <Divider style={{ margin: '20px 0' }} />
            <Typography variant="h6">{t('lblMatches')}</Typography>
            {matchedPairs.map((pair, index) => (
              <React.Fragment key={index}>
                <Grid container alignItems="center">
                  <Grid item xs={1}>
                    <ChevronRightIcon />
                  </Grid>
                  <Grid item xs={9}>
                    <Typography>{pair.material ? `${pair.defect.DefectCode}-${pair.defect.Defect} | ${pair.material?.MaterialCode}-${pair.material?.MaterialDsc}` : `${pair.defect.DefectCode}-${pair.defect.Defect}`}</Typography>
                  </Grid>
                  <Grid item xs={2} style={{ textAlign: 'right' }}>
                    <IconButton onClick={() => handleDeleteMatchedPair(index)}>
                      <DeleteIcon style={{ color: '#9B4444' }} />
                    </IconButton>
                  </Grid>
                </Grid>
              </React.Fragment>
            ))}
            <Divider style={{ margin: '20px 0' }} />
            <Grid container spacing={2} justify="center">
              <Grid item>
                <Tooltip title={t('lblWithoutOrderTip')} arrow>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<RemoveShoppingCartIcon />}
                    endIcon={<span style={{ width: 20 }} />}
                    style={{ backgroundColor: '#8CB9BD' }}
                    onClick={() => TriagePreorderOperations(false)}
                  >
                    <span style={{ margin: '0 auto' }}>{t('lblWithoutOrder')}</span>
                  </Button>
                </Tooltip>
              </Grid>
              <Grid item>
                <Tooltip title={t('lblSaveAndOrder')} arrow>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<SaveIcon />}
                    endIcon={<ShoppingCartIcon />}
                    style={{ backgroundColor: '#344955' }}
                    disabled={!hasMaterialAndDefect}
                    onClick={() => {
                      TriagePreorderOperations(true)
                    }}
                  >
                    <span style={{ margin: '0 auto' }}>{t('lblSaveAndOrderHeader')}</span>
                  </Button>
                </Tooltip>
              </Grid>
            </Grid>
          </React.Fragment>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            endIcon={<CloseIcon />}
            style={{ backgroundColor: '#344955' }}
            onClick={() => setOpenAIDialog(false)}
          >
            <span style={{ margin: '0 auto' }}>{t('lblCancel')}</span>
          </Button>
        </DialogActions>
        <Backdrop open={LoadingControl} style={{ zIndex: 1000 }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Dialog>
      {/* Payment Dialog */}
      <Dialog
        open={showPaymentDialog}
        onClose={handleClosePaymentDialog}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>{t('Payment')}</DialogTitle>
        <DialogContent>
          {/* Payment request already sent — loading indicator */}
          {paymentRequestValidationLoading && (
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12, padding: '8px 12px', background: '#f5f5f5', borderRadius: 8 }}>
              <CircularProgress size={16} style={{ marginRight: 8 }} />
              <Typography variant="body2" color="textSecondary">Checking payment history...</Typography>
            </div>
          )}

          {/* Payment request already sent — warning banner */}
          {!paymentRequestValidationLoading && paymentRequestValidation?.ResponseObject?.IsPaymentAlreadyRequested === true && (
            <div style={{
              display: 'flex',
              alignItems: 'flex-start',
              marginBottom: 16,
              padding: '12px 16px',
              background: '#fff3e0',
              border: '1px solid #ff9800',
              borderRadius: 8,
              borderLeft: '4px solid #e65100'
            }}>
              <WarningIcon style={{ color: '#e65100', marginRight: 12, marginTop: 2, flexShrink: 0 }} />
              <div>
                <Typography variant="subtitle2" style={{ color: '#e65100', fontWeight: 700 }}>
                  Cerere de plată deja trimisă pentru acest ordin de lucru
                </Typography>
                <Typography variant="body2" style={{ color: '#bf360c', marginTop: 4 }}>
                  {paymentRequestValidation.Message}
                  {paymentRequestValidation.ResponseObject?.RepairOrderId && (
                    <span> (Repair Order ID: <strong>{paymentRequestValidation.ResponseObject.RepairOrderId}</strong>)</span>
                  )}
                </Typography>
                <Typography variant="caption" style={{ color: '#e65100', marginTop: 4, display: 'block' }}>
                  Puteți continua, dar clientul s-ar putea să fi primit deja un link de plată.
                </Typography>
              </div>
            </div>
          )}

          {/* POS Machine Selector */}
          <div style={{ marginBottom: 16 }}>
            <Typography variant="subtitle1" style={{ fontWeight: 600, marginBottom: 8 }}>
              POS
            </Typography>
            {posMatchingLoading ? (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <CircularProgress size={20} />
                <Typography variant="body2" style={{ marginLeft: 8 }}>Loading POS machines...</Typography>
              </div>
            ) : posMatchingList.length > 0 ? (
              <FormControl variant="outlined" size="small" fullWidth>
                <InputLabel>POS</InputLabel>
                <Select
                  value={selectedPos}
                  onChange={(e) => setSelectedPos(e.target.value)}
                  label="POS"
                >
                  {(posMatchingList || []).filter(p => p?.Active).map((pos) => (
                    <MenuItem key={pos?.Id} value={pos?.PosMachineIdentifier || ''}>
                      {pos?.PosMachineTypeName || ''} — {pos?.PosMachineIdentifier || ''}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : (
              <Typography variant="body2" color="textSecondary">
                No POS machines found for this employee.
              </Typography>
            )}
          </div>

          {/* RepairPreSale trigger button */}
          <div style={{ marginBottom: 16 }}>
            <Button
              variant="contained"
              color="primary"
              startIcon={<CreditCardIcon />}
              onClick={handleRepairPreSale}
              disabled={repairLoading || totalWithVat <= 0 || !selectedPos || paymentRequestValidation?.ResponseObject?.IsPaymentAlreadyRequested === true}
            >
              {repairLoading
                ? <CircularProgress size={20} color="inherit" />
                : `${t('Payment')} - ${moneyFormat(totalWithVat, SessionUser.TenantCode, SessionUser.CurrencyUnit)} ${paymentCur}`}
            </Button>
          </div>

          {/* Loading state */}
          {repairLoading && (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: 24, minHeight: 120 }}>
              <CircularProgress size={48} />
              <Typography variant="body2" style={{ marginLeft: 12 }}>Processing...</Typography>
            </div>
          )}

          {/* Error display */}
          {(paymentLocalError || repairError) && (
            <div style={{ marginTop: 16 }}>
              <Typography variant="body2" color="error" style={{ fontWeight: 600 }}>
                {paymentLocalError || (typeof repairError === 'string' ? repairError : JSON.stringify(repairError))}
              </Typography>
            </div>
          )}

          {/* Payment reference info */}
          {repairData && !showPaymentIframe && (
            <div style={{ marginTop: 16 }}>
              <Typography variant="body2" color="textSecondary">
                Payment Reference: <strong>{repairData.PaymentReference || '-'}</strong>
              </Typography>
              {repairData.HasApplicationSingleProvider && (
                <Typography variant="body2" color="primary" style={{ marginTop: 4 }}>
                  Payment link has been delivered to the customer.
                </Typography>
              )}
            </div>
          )}

          {/* Payment iframe */}
          {showPaymentIframe && paymentIframeUrl && (
            <div style={{ marginTop: 24 }}>
              <Typography variant="h6" gutterBottom align="center">
                Complete Your Payment
              </Typography>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  minHeight: '400px'
                }}
              >
                <iframe
                  src={paymentIframeUrl}
                  style={{
                    width: '100%',
                    height: '500px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    boxShadow: '0 4px 16px -6px rgba(0,0,0,.18)'
                  }}
                  title="Payment"
                />
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClosePaymentDialog} color="primary">
            {t('iptal')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
Sonlandir.propTypes = {
  className: PropTypes.string,
};
export default connect((state) => ({
  tasks: state.tasks1,
  materialReducer: state.materialReducer,
  defectReducer: state.defectReducer,
  labourReducer: state.labourReducer
}), { setTask, getTasksRequest })(Sonlandir);
